import { FieldReadFunction } from '@apollo/client';

export const collectionByIdRead: FieldReadFunction = (_, { args, toReference }) =>
	toReference({
		__typename: 'Collection',
		id: args.id
	});
